const navitems =  [
  {
    action: "",
    title: "Accueil",
    linkName: "accueil",
    active: true,
    items: []
  },
  {
    action: "",
    title: "Club",
    linkName: "club",
    items: [
      {
        action: "",
        title: "Le comité",
        linkName: "comite",
        items: []
      },
      {
        action: "",
        title: "L'équipe technique",
        linkName: "equipe-technique",
        items: []
      },
      {
        action: "",
        title: "Les gymnases",
        linkName: "gymnases",
        items: []
      },
      {
        action: "",
        title: "Inscription / Licences",
        linkName: "inscription",
        items: []
      },
      {
        action: "",
        title: "Les liens utiles",
        linkName: "ressources",
        items: []
      },
      {
        action: "",
        title: "Les galeries",
        linkName: "galeries",
        items: []
      }
    ]
  },
  {
    action: "",
    title: "Actualités",
    linkName: "actus",
    items: []
  },
  {
    action: "",
    title: "Agenda BOP",
    linkName: "agenda",
    items: []
  },
  {
    action: "",
    title: "Equipes",
    linkName: "equipes",
    items: [
      {
        action: "",
        title: "U7 - Baby-Basket",
        linkName: "equipe",
        query: { slug: "u7" },
        params: {category: "u7"},
        items: []
      },
      {
        action: "",
        title: "U9 - Mini-Poussins",
        linkName: "equipe",
        query: { slug: "u9" },
        params: {category: "u9"},
        items: []
      },
      {
        action: "",
        title: "U11 - Poussins",
        linkName: "equipe",
        query: { slug: "u11" },
        params: {category: "u11"},
        items: []
      },
      {
        action: "",
        title: "U13F - Benjamines",
        linkName: "equipe",
        query: { slug: "u13-filles" },
        params: {category: "u13-filles"},
        items: []
      },
      {
        action: "",
        title: "U13 - Benjamins",
        linkName: "equipe",
        query: { slug: "u13" },
        params: {category: "u13"},
        items: []
      },
      /*{
        action: "",
        title: "U13-2 - Benjamins",
        linkName: "equipe",
        query: { slug: "u13-2" },
        params: {category: "u13-2"},
        items: []
      },*/
      {
        action: "",
        title: "U15F - Minimes",
        linkName: "equipe",
        query: { slug: "u15-filles" },
        params: {category: "u15-filles"},
        items: []
      },
      {
        action: "",
        title: "U15 - Minimes",
        linkName: "equipe",
        query: { slug: "u15" },
        params: {category: "u15"},
        items: []
      },
      /*{
        action: "",
        title: "U17 - Cadets",
        linkName: "equipe",
        query: { slug: "u17" },
        params: {category: "u17"},
        items: []
      },*/
      /*{
        action: "",
        title: "Séniors Féminines",
        linkName: "equipe",
        query: { slug: "seniors-feminines" },
        params: {category: "seniors-feminines"},
        items: []
      }*/
      /*{
        action: "",
        title: "U18 F 3x3",
        linkName: "equipe",
        query: { slug: "u18f-3x3" },
        params: {category: "u18f-3x3"},
        items: []
      },*/
      /*{
        action: "",
        title: "U18 M 3x3",
        linkName: "equipe",
        query: { slug: "u18m-3x3" },
        params: {category: "u18m-3x3"},
        items: []
      },*/
    ]
  },
  {
    action: "",
    title: "Mini-Basket",
    linkName: "mini-basket",
    items: [
      {
        action: "",
        title: "Baby-Basket",
        linkName: "baby-basket",
        items: []
      },
      {
        action: "",
        title: "Opération Basket Ecole",
        linkName: "obe",
        items: []
      }
    ]
  },
  /*{
    action: "",
    title: "Sport-Santé",
    linkName: "sport-sante",
    items: [
      {
        action: "",
        title: "Sport sur ordonnance",
        linkName: "sport-ordonnance",
        items: []
      },
      {
        action: "",
        title: "Basket-Santé",
        linkName: "basket-sante",
        items: []
      }
    ]
  },*/
  {
    action: "",
    title: "Sponsors",
    linkName: "sponsors",
    items: [
      {
        action: "",
        title: "Nos Partenaires",
        linkName: "partenaires",
        items: []
      },
      {
        action: "",
        title: "Devenir Partenaire",
        linkName: "partenariat",
        items: []
      },
      {
        action: "",
        title: "Mécénat / Dons",
        linkName: "mecenat",
        items: []
      }
    ]
  },
  {
    action: "",
    title: "Boutique",
    linkName: "boutique",
    items: []
  },
  {
    action: "",
    title: "Contact",
    linkName: "contact",
    items: []
  }
]

export default navitems;



// WEBPACK FOOTER //
// ./src/store/nav-items.js